<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="fund-settlement">
      <Title jpn="Descrizione basata sulla legge sui servizi di pagamento" />
      <div class="scroll-container">
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Nome della società operativa</span>
            <span class="text">Xero Place Co., Ltd.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">persona rappresentativa</span>
            <span class="text">Yuki Narita</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Indirizzo di registrazione della società/indirizzo dell'ufficio commerciale</span>
            <span class="text">〒330-0854</span>
            <span class="text">1-195-1 Sakuragi-chō, Ōmiya-ku, Saitama-shi,</span>
            <span class="text">Saitama Ōmiya Soramichi KOZ 4° piano</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container left">
            <span class="text">Limite/durata di proprietà della moneta (valuta su questo sito).</span>
            <span class="text">Non esiste un limite massimo per le monete.</span>
            <span class="text">Tuttavia, se sono trascorsi 6 mesi (incluso un giorno) dall'ultimo utilizzo dei Coin senza utilizzarli dopo l'acquisto o lo scambio di Coin, potremmo eliminare il tuo account senza avvisarti in anticipo.</span>
            <span class="text">In questo caso la Moneta non sarà più valida.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container left">
            <span class="text">Intervallo di posizioni di utilizzo delle monete</span>
            <span class="text">Non esiste un limite massimo per le monete.</span>
            <span class="text">Le monete (valuta all'interno di questo sito) possono essere utilizzate all'interno dell'account registrato.</span>
            <span class="text">Inoltre, è vietato il trasferimento di account e il trasferimento di monete.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container left">
            <span class="text">Precauzioni per l'uso</span>
            <span class="text">Le monete (valuta all'interno di questo sito) non possono essere rimborsate.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container left">
            <span class="text">Come controllare le monete che possiedi</span>
            <span class="text">Puoi verificarlo sullo schermo di questo sito.</span>
            <span class="text">Se c'è qualche movimento nelle monete che possiedi, il numero cambierà automaticamente.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container left">
            <span class="text">Informazioni sui contatti</span>
            <span class="text">Vi preghiamo di contattarci qui.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">termini di servizio</span>
            <span class="text">Si prega di verificare i termini di utilizzo di questo sito.</span>
          </div>
        </ShadowBoxTitleDescription>
      </div>
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import ShadowBoxTitleDescription from '@/components/molecules/ShadowBoxTitleDescription.vue';
import Title from '@/components/molecules/Title02.vue';
import t from '@/plugins/i18n';

export default {
  name: 'FundSettlement',
  mixins: [t],

  components: {
    BaseTemplate,
    ShadowBoxTitleDescription,
    Title,
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
    }),
  },

  created() {
    this.$store.dispatch('user/setCurrentUser', { token: 'yugi' });
  },
};
</script>

<style lang="scss" scoped>
.fund-settlement{
  width: 100%;
  max-width: 1000px;
  min-height: 100%;
  padding: 30px 20px 0px;
  margin: 0px auto;
  .fund-settlement-title{
    display: flex;
    justify-content: center;
    .text{
      height: 35px;
      font-family: $notoSerif;
      font-size: 24px;
      font-weight: 700;
    }
  }
  .scroll-container{
    width: 100%;
    margin-top: 30px;
    padding-bottom: 50px;
    max-width: 1000px;
    margin-left: auto;
    margin-right: auto;
    .shadow-box-title-description{
      width: 100%;
      .text-container{
        display: flex;
        flex-direction: column;
        padding: 5px 5px 0px 5px;
        .text{
          font-family: $notoSans;
          font-size: 13px;
          line-height: 1.5;
          letter-spacing: 0.03em;
          a {
            color: $blue!important;
          }
          &.margin-top{
            margin-top: 10px;
          }
          &.one-line-space-top{
            margin-top: 1em;
          }
        }
      }
      & + .shadow-box-title-description{
        margin-top: 40px;
      }
    }
  }
}
@media screen and  (max-width: $tabletWidth) {
  .left {
    text-align: left!important;
  }
}
</style>
